// Quantity Selector

const spins = document.getElementsByClassName("qty");
    for (var i = 0, len = spins.length; i < len; i++) {
      var spin = spins[i],
          span = spin.getElementsByTagName("span"),
          input = spin.getElementsByTagName("input")[0];

      input.onchange = function() {
        input.value = +input.value || 0;
      };
      span[0].onclick = function() {
        input.value = Math.max(1, input.value - 1);
      };
      span[1].onclick = function() {
        input.value -= -1;
      };
    }

// Product Slider 



// Variant ID Form Input Change

async function swatchListener() {

const formInput = document.querySelector('input[name="id"]');

document.querySelectorAll('.product-form__variants').forEach((id) => {
  id.addEventListener('change', async () => {
    formInput.value = id.value;
  });

});

}

swatchListener();

// Accordion

const acc = document.getElementsByClassName("accordion");

for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {

	if( !this.classList.contains('active') ){
    	closeAll();
    }
	
  this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
  
}

function closeAll(){
	 for (i = 0; i < acc.length; i++) {
    	acc[i].classList.remove("active");
        acc[i].nextElementSibling.style.maxHeight = null;
    }
}
acc[0].click();
acc[0].click();